import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5191de33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview page d-flex flex-column" }

import PotreeViewer from "@/components/Viewer/PotreeViewer.vue";
import { ref } from "vue";
import { ViewIndex } from "@/classes/data-structures/view-index";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewPage',
  setup(__props) {

const viewer = ref();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PotreeViewer, {
      ref_key: "viewer",
      ref: viewer,
      "view-index": _unref(ViewIndex).View1,
      "show-ui": false,
      "default-zoom-factor": 0.5
    }, null, 8, ["view-index", "default-zoom-factor"])
  ]))
}
}

})